import { Session } from 'next-auth';

const getAuthSessionUserId = (authSession: Session | null): string | null => {
  let result: string | null = null;
  const userId = authSession?.user?.id;

  if (typeof userId === 'string' && userId.length > 0) {
    result = userId;
  }

  return result;
};

export default getAuthSessionUserId;
